import React from 'react';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import IrpAppService from '../../../../application/platform/scp/irp/irp-app-service';
import { usePagedList } from '../../../../hooks/use-paged-list';
import { dataGridDefaults } from '../../../../components/list-grid-panel';
import { EditAction, DeleteAction, OpenLinkAction } from '../../../../components/row-actions';
import { TwoLineCell } from '../../../../components/two-line-cell';
import { formatDate } from '../../../../utils/date';
import { IIrpPagedResponse } from '../../../../model/scp/irp/response/irp-paged-response';
import { IIrpPageRequest } from '../../../../model/scp/irp/request/irp-paged-request';

export interface IrpDataTableProps {
    parameters: IIrpPageRequest;
    searchTrigger: number;
    onPaginationChange: (page: number, pageSize: number) => void;
    onEdit: (row: IIrpPagedResponse) => void;
    onDelete: (row: IIrpPagedResponse, onDeleted: () => void) => void;
}

export default function IrpDataTable({ parameters, searchTrigger, onPaginationChange, onEdit, onDelete }: IrpDataTableProps) {
    const { rows, rowCount, loading, reload } = usePagedList(IrpAppService.listIrp, parameters, searchTrigger, 'Não foi possível carregar as intenções de registro de preço');

    const columns: GridColDef<IIrpPagedResponse>[] = [
        { field: 'id', headerName: 'Id', width: 90, sortable: false },
        {
            field: 'numberIrp', headerName: 'Nº IRP', minWidth: 160, flex: 0.7, sortable: false,
            renderCell: (params) => <TwoLineCell primary={params.value} secondary={params.row.processNumber ? `Processo ${params.row.processNumber}` : undefined} bold />
        },
        { field: 'year', headerName: 'Exercício', width: 100, sortable: false },
        { field: 'objectIrp', headerName: 'Objeto', flex: 1.5, minWidth: 220, sortable: false },
        { field: 'modality', headerName: 'Modalidade', flex: 1, minWidth: 150, sortable: false },
        {
            field: 'finalInterestManifestationDate', headerName: 'Limite manifestação', width: 160, sortable: false,
            valueFormatter: ({ value }) => formatDate(value),
        },
        {
            field: 'actions', headerName: 'Ações', width: 130, sortable: false, filterable: false,
            renderCell: (params) => (
                <React.Fragment>
                    {params.row.url && <OpenLinkAction url={params.row.url} title="Acessar no portal" />}
                    <EditAction onClick={() => onEdit(params.row)} />
                    <DeleteAction onClick={() => onDelete(params.row, reload)} />
                </React.Fragment>
            )
        }
    ];

    return (
        <DataGrid
            {...dataGridDefaults}
            rows={rows}
            columns={columns}
            loading={loading}
            rowCount={rowCount}
            rowHeight={60}
            paginationMode="server"
            paginationModel={{ page: parameters.page ?? 0, pageSize: parameters.pageSize ?? 100 }}
            onPaginationModelChange={(model) => onPaginationChange(model.page, model.pageSize)}
        />
    );
}
